import { useEffect, useRef } from 'react';
import type { RefObject} from 'react';

type UseFocusInputs = {
  emailInputRef: RefObject<HTMLInputElement>;
  passwordInputRef: RefObject<HTMLInputElement>;
};

/**
 * Hook which manages focusing the correct input at the correct time.
 */
const useFocusInputs = (): UseFocusInputs => {
  //  Store the refs, which will be passed to AuthForm.(EmailInput | PasswordInput).
  const emailInputRef = useRef<HTMLInputElement>(null);
  const passwordInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    //  If there is just an email input, focus it.
    if (emailInputRef.current && !passwordInputRef.current) {
      emailInputRef.current.focus();
      //  Otherwise, if there is a password input, we always want to focus it.
    } else if (passwordInputRef.current) {
      passwordInputRef.current.focus();
    }
  }, [
    emailInputRef.current,
    passwordInputRef.current,
  ]);

  return {
    emailInputRef,
    passwordInputRef,
  };
};

export default useFocusInputs;
